<template>
    <b-modal
        :hide-header="true"
        :hide-footer="true"
        :ok-only="true"
        :id="id"
    >
        <Paragraph class="pt-2 mb-0 font-bold text-xl"> {{ $t(text) }}</Paragraph>
        <!-- Modal body -->

        <HrRow/>
        <div class="modal-body pt-0">
            <RowColumn :is-row-margin-top="false">
                <FormTag>
                    <div class="row">
                        <div class="col-6">
                            {{ $t('autoOrder.orderDate') }}
                        </div>
                        <div class="subtitle_result col-6">
                            {{ dateTimeFormat(new Date()) }}
                        </div>
                        <template v-if="getOrders.length > 0">
                            <div class="col-6 mt-2">
                                {{ $t('autoOrder.lastOrderPeriod') }}
                            </div>
                            <div class="subtitle_result col-6 mt-2">
                                {{ getOrders[0].period }} {{ $t('autoOrder.daily') }}
                            </div>
                        </template>
                    </div>

                    <div class="row mt-5">
                        <template v-if="getOrders.length > 0">
                            <div class="col-6">
                                {{ $t('autoOrder.lastOrderDate') }}
                            </div>
                            <div class="subtitle_result col-6">
                                {{ getLastOrderDate() }}
                            </div>
                        </template>

                        <div class="col-6 mt-2 pt-1">
                            {{ $t('autoOrder.new') }}
                        </div>
                        <div class="col-6 mt-2">
                            <b-form-select v-model="days" class="border-gray-300 focus:ring-0 h-11">
                                <b-form-select-option
                                    v-for="day in period"
                                    :key="day"
                                    :value="day"
                                >
                                    {{ day }} {{ $t('autoOrder.daily') }}
                                </b-form-select-option>
                            </b-form-select>
                        </div>
                    </div>
                </FormTag>
            </RowColumn>
        </div>
        <HrRow/>

        <RowColumn>

            <div class="d-flex">
                <div class="col-12 col-md-6 col-xl-6 mt-4">
                    <SubmitRow
                        text="save"
                        sm-size="12"
                        md-size="12"
                        :is-disabled="false"
                        :do-action="prepareOrder"
                        :is-loading="isLoading"
                    />
                </div>
                <div class="col-12 col-md-6 col-xl-6 mt-4">
                    <b-button
                        class="w-100 h-10"
                        variant="secondary"
                        @click="hideModal"
                    >
                        {{ $t('goBack') }}
                    </b-button>
                </div>
            </div>

        </RowColumn>

    </b-modal>

</template>

<script>
import Paragraph from "@/components/html/Paragraph";
import RowColumn from "@/components/RowColumn";
import FormTag from "@/components/html/FormTag";
import validatorMixin from "@/mixin/validatorMixin";
import accessMixin from "@/mixin/accessMixin";
import {mapActions, mapGetters} from "vuex";
import HrRow from "@/components/html/HrRow.vue";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import SubmitRow from "@/components/SubmitRow.vue";

export default {
    name: "ModalMakeOrder",
    components: {
        HrRow,
        Paragraph,
        RowColumn,
        FormTag,
        SubmitRow,
    },
    mixins: [validatorMixin, accessMixin, dateFormattingMixin],
    props: {
        id: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            isLoading: false,
            orderForm: {
                dateFrom: null,
                dateTo: null,
            },
            supplier: null,
            period: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
            days: 7,
        }
    },
    computed: {
        ...mapGetters(['getOrders', 'getOrder']),
    },
    methods: {
        ...mapActions(['pushOrder', 'fetchOrder']),
        prepareOrder() {
            this.$root.showOverlay = true
            this.prepareOrderPeriod()
            this.pushOrder(this.orderForm)
                .then((response) => {
                    this.hideModal()

                    if (response['hydra:description'] === "No need to order") {
                        this.$emit('notNeedOrder', response)
                        return
                    }

                    this.fetchOrder(response.id)
                        .then(() => {
                            this.showAfterOrderInfo()
                            this.$i18nHelper.toUrl('orders/' + response.id)
                        })
                        .finally(() => {
                            this.$root.showOverlay = false
                        })
                })
                .catch((reason) => {
                    this.hideModal()
                    this.$emit('saleNotFound', reason)
                    this.$root.showOverlay = false
                })
        },
        prepareOrderPeriod() {
            let date = new Date()
            this.orderForm.dateTo = date.toISOString()
            date.setDate(date.getDate() - this.days)
            date.setHours(5, 0, 0)
            this.orderForm.dateFrom = date.toISOString()
        },
        getLastOrderDate() {
            let period = {}

            period.from = this.dateFormat(new Date(new Date().setDate(new Date().getDate() - this.getOrders[0].period)).toISOString())
            period.to = this.dateFormat(this.getOrders[0].createdAt)

            return period.from + ' -- ' + period.to
        },
        hideModal() {
            this.$bvModal.hide('make_order')
        },
        showAfterOrderInfo() {
            if (this.$i18n.locale === 'uz') {
                this.$i18nHelper.flash(this.dateFormat(this.orderForm.dateFrom) + ' dan ' +
                    this.dateFormat(this.orderForm.dateTo) + ' gacha ' + this.getOrder.autoOrderItems.length +
                    ' ta mahsulot avtobuyurtmasi shakllantirildi', 'success')
            } else if (this.$i18n.locale === 'ru') {
                this.$i18nHelper.flash('С ' + this.dateFormat(this.orderForm.dateFrom) + ' по ' +
                    this.dateFormat(this.orderForm.dateTo) + ' создано автозаказ на ' + this.getOrder.autoOrderItems.length +
                    ' товаров', 'success')
            } else {
                this.$i18nHelper.flash('From ' + this.dateFormat(this.orderForm.dateFrom) + ' to ' +
                    this.dateFormat(this.orderForm.dateTo) + ', ' + this.getOrder.autoOrderItems.length +
                    ' product auto orders were created', 'success')
            }
        },
    },
}
</script>

<style scoped>

.subtitle_result {
    font-weight: 600;
}
</style>
